module.exports = __webpack_public_path__ + "static/img/sketch-figma-to-frontier.8a545de4.svg";